const countryList = [
  { value: "South Africa", text: "South Africa" },
  { value: "Bangladesh", text: "Bangladesh" },
  { value: "Belgium", text: "Belgium" },
  { value: "Burkina Faso", text: "Burkina Faso" },
  { value: "Bulgaria", text: "Bulgaria" },
  { value: "Bosnia and Herzegovina", text: "Bosnia and Herzegovina" },
  { value: "Barbados", text: "Barbados" },
  { value: "Wallis and Futuna", text: "Wallis and Futuna" },
  { value: "Saint Barthelemy", text: "Saint Barthelemy" },
  { value: "Bermuda", text: "Bermuda" },
  { value: "Brunei", text: "Brunei" },
  { value: "Bolivia", text: "Bolivia" },
  { value: "Bahrain", text: "Bahrain" },
  { value: "Burundi", text: "Burundi" },
  { value: "Benin", text: "Benin" },
  { value: "Bhutan", text: "Bhutan" },
  { value: "Jamaica", text: "Jamaica" },
  { value: "Bouvet Island", text: "Bouvet Island" },
  { value: "Botswana", text: "Botswana" },
  { value: "Samoa", text: "Samoa" },
  {
    value: "Bonaire, Saint Eustatius and Saba ",
    text: "Bonaire, Saint Eustatius and Saba ",
  },
  { value: "Brazil", text: "Brazil" },
  { value: "Bahamas", text: "Bahamas" },
  { value: "Jersey", text: "Jersey" },
  { value: "Belarus", text: "Belarus" },
  { value: "Belize", text: "Belize" },
  { value: "Russia", text: "Russia" },
  { value: "Rwanda", text: "Rwanda" },
  { value: "Serbia", text: "Serbia" },
  { value: "East Timor", text: "East Timor" },
  { value: "Reunion", text: "Reunion" },
  { value: "Turkmenistan", text: "Turkmenistan" },
  { value: "Tajikistan", text: "Tajikistan" },
  { value: "Romania", text: "Romania" },
  { value: "Tokelau", text: "Tokelau" },
  { value: "Guinea-Bissau", text: "Guinea-Bissau" },
  { value: "Guam", text: "Guam" },
  { value: "Guatemala", text: "Guatemala" },
  {
    value: "South Georgia and the South Sandwich Islands",
    text: "South Georgia and the South Sandwich Islands",
  },
  { value: "Greece", text: "Greece" },
  { value: "Equatorial Guinea", text: "Equatorial Guinea" },
  { value: "Guadeloupe", text: "Guadeloupe" },
  { value: "Japan", text: "Japan" },
  { value: "Guyana", text: "Guyana" },
  { value: "Guernsey", text: "Guernsey" },
  { value: "French Guiana", text: "French Guiana" },
  { value: "Georgia", text: "Georgia" },
  { value: "Grenada", text: "Grenada" },
  { value: "United Kingdom", text: "United Kingdom" },
  { value: "Gabon", text: "Gabon" },
  { value: "El Salvador", text: "El Salvador" },
  { value: "Guinea", text: "Guinea" },
  { value: "Gambia", text: "Gambia" },
  { value: "Greenland", text: "Greenland" },
  { value: "Gibraltar", text: "Gibraltar" },
  { value: "Ghana", text: "Ghana" },
  { value: "Oman", text: "Oman" },
  { value: "Tunisia", text: "Tunisia" },
  { value: "Jordan", text: "Jordan" },
  { value: "Croatia", text: "Croatia" },
  { value: "Haiti", text: "Haiti" },
  { value: "Hungary", text: "Hungary" },
  { value: "Hong Kong", text: "Hong Kong" },
  { value: "Honduras", text: "Honduras" },
  {
    value: "Heard Island and McDonald Islands",
    text: "Heard Island and McDonald Islands",
  },
  { value: "Venezuela", text: "Venezuela" },
  { value: "Puerto Rico", text: "Puerto Rico" },
  { value: "Palestinian Territory", text: "Palestinian Territory" },
  { value: "Palau", text: "Palau" },
  { value: "Portugal", text: "Portugal" },
  { value: "Svalbard and Jan Mayen", text: "Svalbard and Jan Mayen" },
  { value: "Paraguay", text: "Paraguay" },
  { value: "Iraq", text: "Iraq" },
  { value: "Panama", text: "Panama" },
  { value: "French Polynesia", text: "French Polynesia" },
  { value: "Papua New Guinea", text: "Papua New Guinea" },
  { value: "Peru", text: "Peru" },
  { value: "Pakistan", text: "Pakistan" },
  { value: "Philippines", text: "Philippines" },
  { value: "Pitcairn", text: "Pitcairn" },
  { value: "Poland", text: "Poland" },
  { value: "Saint Pierre and Miquelon", text: "Saint Pierre and Miquelon" },
  { value: "Zambia", text: "Zambia" },
  { value: "Western Sahara", text: "Western Sahara" },
  { value: "Estonia", text: "Estonia" },
  { value: "Egypt", text: "Egypt" },
  { value: "Ecuador", text: "Ecuador" },
  { value: "Italy", text: "Italy" },
  { value: "Vietnam", text: "Vietnam" },
  { value: "Solomon Islands", text: "Solomon Islands" },
  { value: "Ethiopia", text: "Ethiopia" },
  { value: "Somalia", text: "Somalia" },
  { value: "Zimbabwe", text: "Zimbabwe" },
  { value: "Saudi Arabia", text: "Saudi Arabia" },
  { value: "Spain", text: "Spain" },
  { value: "Eritrea", text: "Eritrea" },
  { value: "Montenegro", text: "Montenegro" },
  { value: "Moldova", text: "Moldova" },
  { value: "Madagascar", text: "Madagascar" },
  { value: "Saint Martin", text: "Saint Martin" },
  { value: "Morocco", text: "Morocco" },
  { value: "Monaco", text: "Monaco" },
  { value: "Uzbekistan", text: "Uzbekistan" },
  { value: "Myanmar", text: "Myanmar" },
  { value: "Mali", text: "Mali" },
  { value: "Macao", text: "Macao" },
  { value: "Mongolia", text: "Mongolia" },
  { value: "Marshall Islands", text: "Marshall Islands" },
  { value: "Macedonia", text: "Macedonia" },
  { value: "Mauritius", text: "Mauritius" },
  { value: "Malta", text: "Malta" },
  { value: "Malawi", text: "Malawi" },
  { value: "Maldives", text: "Maldives" },
  { value: "Martinique", text: "Martinique" },
  { value: "Northern Mariana Islands", text: "Northern Mariana Islands" },
  { value: "Montserrat", text: "Montserrat" },
  { value: "Mauritania", text: "Mauritania" },
  { value: "Isle of Man", text: "Isle of Man" },
  { value: "Uganda", text: "Uganda" },
  { value: "Tanzania", text: "Tanzania" },
  { value: "Malaysia", text: "Malaysia" },
  { value: "Mexico", text: "Mexico" },
  { value: "Israel", text: "Israel" },
  { value: "France", text: "France" },
  {
    value: "British Indian Ocean Territory",
    text: "British Indian Ocean Territory",
  },
  { value: "Saint Helena", text: "Saint Helena" },
  { value: "Finland", text: "Finland" },
  { value: "Fiji", text: "Fiji" },
  { value: "Falkland Islands", text: "Falkland Islands" },
  { value: "Micronesia", text: "Micronesia" },
  { value: "Faroe Islands", text: "Faroe Islands" },
  { value: "Nicaragua", text: "Nicaragua" },
  { value: "Netherlands", text: "Netherlands" },
  { value: "Norway", text: "Norway" },
  { value: "Namibia", text: "Namibia" },
  { value: "Vanuatu", text: "Vanuatu" },
  { value: "New Caledonia", text: "New Caledonia" },
  { value: "Niger", text: "Niger" },
  { value: "Norfolk Island", text: "Norfolk Island" },
  { value: "Nigeria", text: "Nigeria" },
  { value: "New Zealand", text: "New Zealand" },
  { value: "Nepal", text: "Nepal" },
  { value: "Nauru", text: "Nauru" },
  { value: "Niue", text: "Niue" },
  { value: "Cook Islands", text: "Cook Islands" },
  { value: "Kosovo", text: "Kosovo" },
  { value: "Ivory Coast", text: "Ivory Coast" },
  { value: "Switzerland", text: "Switzerland" },
  { value: "Colombia", text: "Colombia" },
  { value: "China", text: "China" },
  { value: "Cameroon", text: "Cameroon" },
  { value: "Chile", text: "Chile" },
  { value: "Cocos Islands", text: "Cocos Islands" },
  { value: "Canada", text: "Canada" },
  { value: "Republic of the Congo", text: "Republic of the Congo" },
  { value: "Central African Republic", text: "Central African Republic" },
  {
    value: "Democratic Republic of the Congo",
    text: "Democratic Republic of the Congo",
  },
  { value: "Czech Republic", text: "Czech Republic" },
  { value: "Cyprus", text: "Cyprus" },
  { value: "Christmas Island", text: "Christmas Island" },
  { value: "Costa Rica", text: "Costa Rica" },
  { value: "Curacao", text: "Curacao" },
  { value: "Cape Verde", text: "Cape Verde" },
  { value: "Cuba", text: "Cuba" },
  { value: "Swaziland", text: "Swaziland" },
  { value: "Syria", text: "Syria" },
  { value: "Sint Maarten", text: "Sint Maarten" },
  { value: "Kyrgyzstan", text: "Kyrgyzstan" },
  { value: "Kenya", text: "Kenya" },
  { value: "South Sudan", text: "South Sudan" },
  { value: "Suriname", text: "Suriname" },
  { value: "Kiribati", text: "Kiribati" },
  { value: "Cambodia", text: "Cambodia" },
  { value: "Saint Kitts and Nevis", text: "Saint Kitts and Nevis" },
  { value: "Comoros", text: "Comoros" },
  { value: "Sao Tome and Principe", text: "Sao Tome and Principe" },
  { value: "Slovakia", text: "Slovakia" },
  { value: "South Korea", text: "South Korea" },
  { value: "Slovenia", text: "Slovenia" },
  { value: "North Korea", text: "North Korea" },
  { value: "Kuwait", text: "Kuwait" },
  { value: "Senegal", text: "Senegal" },
  { value: "San Marino", text: "San Marino" },
  { value: "Sierra Leone", text: "Sierra Leone" },
  { value: "Seychelles", text: "Seychelles" },
  { value: "Kazakhstan", text: "Kazakhstan" },
  { value: "Cayman Islands", text: "Cayman Islands" },
  { value: "Singapore", text: "Singapore" },
  { value: "Sweden", text: "Sweden" },
  { value: "Sudan", text: "Sudan" },
  { value: "Dominican Republic", text: "Dominican Republic" },
  { value: "Dominica", text: "Dominica" },
  { value: "Djibouti", text: "Djibouti" },
  { value: "Denmark", text: "Denmark" },
  { value: "British Virgin Islands", text: "British Virgin Islands" },
  { value: "Germany", text: "Germany" },
  { value: "Yemen", text: "Yemen" },
  { value: "Algeria", text: "Algeria" },
  { value: "United States", text: "United States" },
  { value: "Uruguay", text: "Uruguay" },
  { value: "Mayotte", text: "Mayotte" },
  {
    value: "United States Minor Outlying Islands",
    text: "United States Minor Outlying Islands",
  },
  { value: "Lebanon", text: "Lebanon" },
  { value: "Saint Lucia", text: "Saint Lucia" },
  { value: "Laos", text: "Laos" },
  { value: "Tuvalu", text: "Tuvalu" },
  { value: "Taiwan", text: "Taiwan" },
  { value: "Trinidad and Tobago", text: "Trinidad and Tobago" },
  { value: "Turkey", text: "Turkey" },
  { value: "Sri Lanka", text: "Sri Lanka" },
  { value: "Liechtenstein", text: "Liechtenstein" },
  { value: "Latvia", text: "Latvia" },
  { value: "Tonga", text: "Tonga" },
  { value: "Lithuania", text: "Lithuania" },
  { value: "Luxembourg", text: "Luxembourg" },
  { value: "Liberia", text: "Liberia" },
  { value: "Lesotho", text: "Lesotho" },
  { value: "Thailand", text: "Thailand" },
  { value: "French Southern Territories", text: "French Southern Territories" },
  { value: "Togo", text: "Togo" },
  { value: "Chad", text: "Chad" },
  { value: "Turks and Caicos Islands", text: "Turks and Caicos Islands" },
  { value: "Libya", text: "Libya" },
  { value: "Vatican", text: "Vatican" },
  {
    value: "Saint Vincent and the Grenadines",
    text: "Saint Vincent and the Grenadines",
  },
  { value: "United Arab Emirates", text: "United Arab Emirates" },
  { value: "Andorra", text: "Andorra" },
  { value: "Antigua and Barbuda", text: "Antigua and Barbuda" },
  { value: "Afghanistan", text: "Afghanistan" },
  { value: "Anguilla", text: "Anguilla" },
  { value: "U.S. Virgin Islands", text: "U.S. Virgin Islands" },
  { value: "Iceland", text: "Iceland" },
  { value: "Iran", text: "Iran" },
  { value: "Armenia", text: "Armenia" },
  { value: "Albania", text: "Albania" },
  { value: "Angola", text: "Angola" },
  { value: "Antarctica", text: "Antarctica" },
  { value: "American Samoa", text: "American Samoa" },
  { value: "Argentina", text: "Argentina" },
  { value: "Australia", text: "Australia" },
  { value: "Austria", text: "Austria" },
  { value: "Aruba", text: "Aruba" },
  { value: "India", text: "India" },
  { value: "Aland Islands", text: "Aland Islands" },
  { value: "Azerbaijan", text: "Azerbaijan" },
  { value: "Ireland", text: "Ireland" },
  { value: "Indonesia", text: "Indonesia" },
  { value: "Ukraine", text: "Ukraine" },
  { value: "Qatar", text: "Qatar" },
  { value: "Mozambique", text: "Mozambique" },
];
  // { value: "+27", text: "+27 (ZA)" },
  // { value: "+267", text: "+267 (BW)" },
  // { value: "+266", text: "+266 (LS)" },
  // { value: "+264", text: "+264 (NA)" },
  // { value: "+268", text: "+268 (SZ)" },
  // { value: "+260", text: "+260 (ZM)" },
  // { value: "+263", text: "+263 (ZW)" },

export const areaCodes = [
  { value: "+93", text: "+93 (AF)", countryName: "Afghanistan" },
  { value: "+355", text: "+355 (AL)", countryName: "Albania" },
  { value: "+213", text: "+213 (DZ)", countryName: "Algeria" },
  { value: "+1-684", text: "+1-684 (AS)", countryName: "American Samoa" },
  { value: "+376", text: "+376 (AD)", countryName: "Andorra" },
  { value: "+244", text: "+244 (AO)", countryName: "Angola" },
  { value: "+1-264", text: "+1-264 (AI)", countryName: "Anguilla" },
  { value: "+672", text: "+672 (AQ)", countryName: "Antarctica" },
  { value: "+1-268", text: "+1-268 (AG)", countryName: "Antigua and Barbuda" },
  { value: "+54", text: "+54 (AR)", countryName: "Argentina" },
  { value: "+374", text: "+374 (AM)", countryName: "Armenia" },
  { value: "+297", text: "+297 (AW)", countryName: "Aruba" },
  { value: "+61", text: "+61 (AU)", countryName: "Australia" },
  { value: "+43", text: "+43 (AT)", countryName: "Austria" },
  { value: "+994", text: "+994 (AZ)", countryName: "Azerbaijan" },
  { value: "+1-242", text: "+1-242 (BS)", countryName: "Bahamas" },
  { value: "+973", text: "+973 (BH)", countryName: "Bahrain" },
  { value: "+880", text: "+880 (BD)", countryName: "Bangladesh" },
  { value: "+1-246", text: "+1-246 (BB)", countryName: "Barbados" },
  { value: "+375", text: "+375 (BY)", countryName: "Belarus" },
  { value: "+32", text: "+32 (BE)", countryName: "Belgium" },
  { value: "+501", text: "+501 (BZ)", countryName: "Belize" },
  { value: "+229", text: "+229 (BJ)", countryName: "Benin" },
  { value: "+1-441", text: "+1-441 (BM)", countryName: "Bermuda" },
  { value: "+975", text: "+975 (BT)", countryName: "Bhutan" },
  { value: "+591", text: "+591 (BO)", countryName: "Bolivia" },
  { value: "+387", text: "+387 (BA)", countryName: "Bosnia and Herzegovina" },
  { value: "+267", text: "+267 (BW)", countryName: "Botswana" },
  { value: "+55", text: "+55 (BR)", countryName: "Brazil" },
  { value: "+246", text: "+246 (IO)", countryName: "British Indian Ocean Territory" },
  { value: "+1-284", text: "+1-284 (VG)", countryName: "British Virgin Islands" },
  { value: "+673", text: "+673 (BN)", countryName: "Brunei" },
  { value: "+359", text: "+359 (BG)", countryName: "Bulgaria" },
  { value: "+226", text: "+226 (BF)", countryName: "Burkina Faso" },
  { value: "+257", text: "+257 (BI)", countryName: "Burundi" },
  { value: "+855", text: "+855 (KH)", countryName: "Cambodia" },
  { value: "+237", text: "+237 (CM)", countryName: "Cameroon" },
  { value: "+1", text: "+1 (CA)", countryName: "Canada" },
  { value: "+238", text: "+238 (CV)", countryName: "Cape Verde" },
  { value: "+1-345", text: "+1-345 (KY)", countryName: "Cayman Islands" },
  { value: "+236", text: "+236 (CF)", countryName: "Central African Republic" },
  { value: "+235", text: "+235 (TD)", countryName: "Chad" },
  { value: "+56", text: "+56 (CL)", countryName: "Chile" },
  { value: "+86", text: "+86 (CN)", countryName: "China" },
  { value: "+61", text: "+61 (CX)", countryName: "Christmas Island" },
  { value: "+61", text: "+61 (CC)", countryName: "Cocos Islands" },
  { value: "+57", text: "+57 (CO)", countryName: "Colombia" },
  { value: "+269", text: "+269 (KM)", countryName: "Comoros" },
  { value: "+682", text: "+682 (CK)", countryName: "Cook Islands" },
  { value: "+506", text: "+506 (CR)", countryName: "Costa Rica" },
  { value: "+385", text: "+385 (HR)", countryName: "Croatia" },
  { value: "+53", text: "+53 (CU)", countryName: "Cuba" },
  { value: "+599", text: "+599 (CW)", countryName: "Curacao" },
  { value: "+357", text: "+357 (CY)", countryName: "Cyprus" },
  { value: "+420", text: "+420 (CZ)", countryName: "Czech Republic" },
  { value: "+243", text: "+243 (CD)", countryName: "Democratic Republic of the Congo" },
  { value: "+45", text: "+45 (DK)", countryName: "Denmark" },
  { value: "+253", text: "+253 (DJ)", countryName: "Djibouti" },
  { value: "+1-767", text: "+1-767 (DM)", countryName: "Dominica" },
  { value: "+1-809, 1-829, 1-849", text: "+1-809, 1-829, 1-849 (DO)", countryName: "Dominican Republic" },
  { value: "+670", text: "+670 (TL)", countryName: "East Timor" },
  { value: "+593", text: "+593 (EC)", countryName: "Ecuador" },
  { value: "+20", text: "+20 (EG)", countryName: "Egypt" },
  { value: "+503", text: "+503 (SV)", countryName: "El Salvador" },
  { value: "+240", text: "+240 (GQ)", countryName: "Equatorial Guinea" },
  { value: "+291", text: "+291 (ER)", countryName: "Eritrea" },
  { value: "+372", text: "+372 (EE)", countryName: "Estonia" },
  { value: "+251", text: "+251 (ET)", countryName: "Ethiopia" },
  { value: "+500", text: "+500 (FK)", countryName: "Falkland Islands" },
  { value: "+298", text: "+298 (FO)", countryName: "Faroe Islands" },
  { value: "+679", text: "+679 (FJ)", countryName: "Fiji" },
  { value: "+358", text: "+358 (FI)", countryName: "Finland" },
  { value: "+33", text: "+33 (FR)", countryName: "France" },
  { value: "+689", text: "+689 (PF)", countryName: "French Polynesia" },
  { value: "+241", text: "+241 (GA)", countryName: "Gabon" },
  { value: "+220", text: "+220 (GM)", countryName: "Gambia" },
  { value: "+995", text: "+995 (GE)", countryName: "Georgia" },
  { value: "+49", text: "+49 (DE)", countryName: "Germany" },
  { value: "+233", text: "+233 (GH)", countryName: "Ghana" },
  { value: "+350", text: "+350 (GI)", countryName: "Gibraltar" },
  { value: "+30", text: "+30 (GR)", countryName: "Greece" },
  { value: "+299", text: "+299 (GL)", countryName: "Greenland" },
  { value: "+1-473", text: "+1-473 (GD)", countryName: "Grenada" },
  { value: "+1-671", text: "+1-671 (GU)", countryName: "Guam" },
  { value: "+502", text: "+502 (GT)", countryName: "Guatemala" },
  { value: "+44-1481", text: "+44-1481 (GG)", countryName: "Guernsey" },
  { value: "+224", text: "+224 (GN)", countryName: "Guinea" },
  { value: "+245", text: "+245 (GW)", countryName: "Guinea-Bissau" },
  { value: "+592", text: "+592 (GY)", countryName: "Guyana" },
  { value: "+509", text: "+509 (HT)", countryName: "Haiti" },
  { value: "+504", text: "+504 (HN)", countryName: "Honduras" },
  { value: "+852", text: "+852 (HK)", countryName: "Hong Kong" },
  { value: "+36", text: "+36 (HU)", countryName: "Hungary" },
  { value: "+354", text: "+354 (IS)", countryName: "Iceland" },
  { value: "+91", text: "+91 (IN)", countryName: "India" },
  { value: "+62", text: "+62 (ID)", countryName: "Indonesia" },
  { value: "+98", text: "+98 (IR)", countryName: "Iran" },
  { value: "+964", text: "+964 (IQ)", countryName: "Iraq" },
  { value: "+353", text: "+353 (IE)", countryName: "Ireland" },
  { value: "+44-1624", text: "+44-1624 (IM)", countryName: "Isle of Man" },
  { value: "+972", text: "+972 (IL)", countryName: "Israel" },
  { value: "+39", text: "+39 (IT)", countryName: "Italy" },
  { value: "+225", text: "+225 (CI)", countryName: "Ivory Coast" },
  { value: "+1-876", text: "+1-876 (JM)", countryName: "Jamaica" },
  { value: "+81", text: "+81 (JP)", countryName: "Japan" },
  { value: "+44-1534", text: "+44-1534 (JE)", countryName: "Jersey" },
  { value: "+962", text: "+962 (JO)", countryName: "Jordan" },
  { value: "+7", text: "+7 (KZ)", countryName: "Kazakhstan" },
  { value: "+254", text: "+254 (KE)", countryName: "Kenya" },
  { value: "+686", text: "+686 (KI)", countryName: "Kiribati" },
  { value: "+383", text: "+383 (XK)", countryName: "Kosovo" },
  { value: "+965", text: "+965 (KW)", countryName: "Kuwait" },
  { value: "+996", text: "+996 (KG)", countryName: "Kyrgyzstan" },
  { value: "+856", text: "+856 (LA)", countryName: "Laos" },
  { value: "+371", text: "+371 (LV)", countryName: "Latvia" },
  { value: "+961", text: "+961 (LB)", countryName: "Lebanon" },
  { value: "+266", text: "+266 (LS)", countryName: "Lesotho" },
  { value: "+231", text: "+231 (LR)", countryName: "Liberia" },
  { value: "+218", text: "+218 (LY)", countryName: "Libya" },
  { value: "+423", text: "+423 (LI)", countryName: "Liechtenstein" },
  { value: "+370", text: "+370 (LT)", countryName: "Lithuania" },
  { value: "+352", text: "+352 (LU)", countryName: "Luxembourg" },
  { value: "+853", text: "+853 (MO)", countryName: "Macao" },
  { value: "+389", text: "+389 (MK)", countryName: "Macedonia" },
  { value: "+261", text: "+261 (MG)", countryName: "Madagascar" },
  { value: "+265", text: "+265 (MW)", countryName: "Malawi" },
  { value: "+60", text: "+60 (MY)", countryName: "Malaysia" },
  { value: "+960", text: "+960 (MV)", countryName: "Maldives" },
  { value: "+223", text: "+223 (ML)", countryName: "Mali" },
  { value: "+356", text: "+356 (MT)", countryName: "Malta" },
  { value: "+692", text: "+692 (MH)", countryName: "Marshall Islands" },
  { value: "+222", text: "+222 (MR)", countryName: "Mauritania" },
  { value: "+230", text: "+230 (MU)", countryName: "Mauritius" },
  { value: "+262", text: "+262 (YT)", countryName: "Mayotte" },
  { value: "+52", text: "+52 (MX)", countryName: "Mexico" },
  { value: "+691", text: "+691 (FM)", countryName: "Micronesia" },
  { value: "+373", text: "+373 (MD)", countryName: "Moldova" },
  { value: "+377", text: "+377 (MC)", countryName: "Monaco" },
  { value: "+976", text: "+976 (MN)", countryName: "Mongolia" },
  { value: "+382", text: "+382 (ME)", countryName: "Montenegro" },
  { value: "+1-664", text: "+1-664 (MS)", countryName: "Montserrat" },
  { value: "+212", text: "+212 (MA)", countryName: "Morocco" },
  { value: "+258", text: "+258 (MZ)", countryName: "Mozambique" },
  { value: "+95", text: "+95 (MM)", countryName: "Myanmar" },
  { value: "+264", text: "+264 (NA)", countryName: "Namibia" },
  { value: "+674", text: "+674 (NR)", countryName: "Nauru" },
  { value: "+977", text: "+977 (NP)", countryName: "Nepal" },
  { value: "+31", text: "+31 (NL)", countryName: "Netherlands" },
  { value: "+599", text: "+599 (AN)", countryName: "Netherlands Antilles" },
  { value: "+687", text: "+687 (NC)", countryName: "New Caledonia" },
  { value: "+64", text: "+64 (NZ)", countryName: "New Zealand" },
  { value: "+505", text: "+505 (NI)", countryName: "Nicaragua" },
  { value: "+227", text: "+227 (NE)", countryName: "Niger" },
  { value: "+234", text: "+234 (NG)", countryName: "Nigeria" },
  { value: "+683", text: "+683 (NU)", countryName: "Niue" },
  { value: "+850", text: "+850 (KP)", countryName: "North Korea" },
  { value: "+1-670", text: "+1-670 (MP)", countryName: "Northern Mariana Islands" },
  { value: "+47", text: "+47 (NO)", countryName: "Norway" },
  { value: "+968", text: "+968 (OM)", countryName: "Oman" },
  { value: "+92", text: "+92 (PK)", countryName: "Pakistan" },
  { value: "+680", text: "+680 (PW)", countryName: "Palau" },
  { value: "+970", text: "+970 (PS)", countryName: "Palestinian Territory" },
  { value: "+507", text: "+507 (PA)", countryName: "Panama" },
  { value: "+675", text: "+675 (PG)", countryName: "Papua New Guinea" },
  { value: "+595", text: "+595 (PY)", countryName: "Paraguay" },
  { value: "+51", text: "+51 (PE)", countryName: "Peru" },
  { value: "+63", text: "+63 (PH)", countryName: "Philippines" },
  { value: "+64", text: "+64 (PN)", countryName: "Pitcairn" },
  { value: "+48", text: "+48 (PL)", countryName: "Poland" },
  { value: "+351", text: "+351 (PT)", countryName: "Portugal" },
  { value: "+1-787, 1-939", text: "+1-787, 1-939 (PR)", countryName: "Puerto Rico" },
  { value: "+974", text: "+974 (QA)", countryName: "Qatar" },
  { value: "+242", text: "+242 (CG)", countryName: "Republic of the Congo" },
  { value: "+262", text: "+262 (RE)", countryName: "Reunion" },
  { value: "+40", text: "+40 (RO)", countryName: "Romania" },
  { value: "+7", text: "+7 (RU)", countryName: "Russia" },
  { value: "+250", text: "+250 (RW)", countryName: "Rwanda" },
  { value: "+590", text: "+590 (BL)", countryName: "Saint Barthelemy" },
  { value: "+290", text: "+290 (SH)", countryName: "Saint Helena" },
  { value: "+1-869", text: "+1-869 (KN)", countryName: "Saint Kitts and Nevis" },
  { value: "+1-758", text: "+1-758 (LC)", countryName: "Saint Lucia" },
  { value: "+590", text: "+590 (MF)", countryName: "Saint Martin" },
  { value: "+508", text: "+508 (PM)", countryName: "Saint Pierre and Miquelon" },
  { value: "+1-784", text: "+1-784 (VC)", countryName: "Saint Vincent and the Grenadines" },
  { value: "+685", text: "+685 (WS)", countryName: "Samoa" },
  { value: "+378", text: "+378 (SM)", countryName: "San Marino" },
  { value: "+239", text: "+239 (ST)", countryName: "Sao Tome and Principe" },
  { value: "+966", text: "+966 (SA)", countryName: "Saudi Arabia" },
  { value: "+221", text: "+221 (SN)", countryName: "Senegal" },
  { value: "+381", text: "+381 (RS)", countryName: "Serbia" },
  { value: "+248", text: "+248 (SC)", countryName: "Seychelles" },
  { value: "+232", text: "+232 (SL)", countryName: "Sierra Leone" },
  { value: "+65", text: "+65 (SG)", countryName: "Singapore" },
  { value: "+1-721", text: "+1-721 (SX)", countryName: "Sint Maarten" },
  { value: "+421", text: "+421 (SK)", countryName: "Slovakia" },
  { value: "+386", text: "+386 (SI)", countryName: "Slovenia" },
  { value: "+677", text: "+677 (SB)", countryName: "Solomon Islands" },
  { value: "+252", text: "+252 (SO)", countryName: "Somalia" },
  { value: "+27", text: "+27 (ZA)", countryName: "South Africa" },
  { value: "+82", text: "+82 (KR)", countryName: "South Korea" },
  { value: "+211", text: "+211 (SS)", countryName: "South Sudan" },
  { value: "+34", text: "+34 (ES)", countryName: "Spain" },
  { value: "+94", text: "+94 (LK)", countryName: "Sri Lanka" },
  { value: "+249", text: "+249 (SD)", countryName: "Sudan" },
  { value: "+597", text: "+597 (SR)", countryName: "Suriname" },
  { value: "+47", text: "+47 (SJ)", countryName: "Svalbard and Jan Mayen" },
  { value: "+268", text: "+268 (SZ)", countryName: "Swaziland" },
  { value: "+46", text: "+46 (SE)", countryName: "Sweden" },
  { value: "+41", text: "+41 (CH)", countryName: "Switzerland" },
  { value: "+963", text: "+963 (SY)", countryName: "Syria" },
  { value: "+886", text: "+886 (TW)", countryName: "Taiwan" },
  { value: "+992", text: "+992 (TJ)", countryName: "Tajikistan" },
  { value: "+255", text: "+255 (TZ)", countryName: "Tanzania" },
  { value: "+66", text: "+66 (TH)", countryName: "Thailand" },
  { value: "+228", text: "+228 (TG)", countryName: "Togo" },
  { value: "+690", text: "+690 (TK)", countryName: "Tokelau" },
  { value: "+676", text: "+676 (TO)", countryName: "Tonga" },
  { value: "+1-868", text: "+1-868 (TT)", countryName: "Trinidad and Tobago" },
  { value: "+216", text: "+216 (TN)", countryName: "Tunisia" },
  { value: "+90", text: "+90 (TR)", countryName: "Turkey" },
  { value: "+993", text: "+993 (TM)", countryName: "Turkmenistan" },
  { value: "+1-649", text: "+1-649 (TC)", countryName: "Turks and Caicos Islands" },
  { value: "+688", text: "+688 (TV)", countryName: "Tuvalu" },
  { value: "+1-340", text: "+1-340 (VI)", countryName: "U.S. Virgin Islands" },
  { value: "+256", text: "+256 (UG)", countryName: "Uganda" },
  { value: "+380", text: "+380 (UA)", countryName: "Ukraine" },
  { value: "+971", text: "+971 (AE)", countryName: "United Arab Emirates" },
  { value: "+44", text: "+44 (GB)", countryName: "United Kingdom" },
  { value: "+1", text: "+1 (US)", countryName: "United States" },
  { value: "+598", text: "+598 (UY)", countryName: "Uruguay" },
  { value: "+998", text: "+998 (UZ)", countryName: "Uzbekistan" },
  { value: "+678", text: "+678 (VU)", countryName: "Vanuatu" },
  { value: "+379", text: "+379 (VA)", countryName: "Vatican" },
  { value: "+58", text: "+58 (VE)", countryName: "Venezuela" },
  { value: "+84", text: "+84 (VN)", countryName: "Vietnam" },
  { value: "+681", text: "+681 (WF)", countryName: "Wallis and Futuna" },
  { value: "+212", text: "+212 (EH)", countryName: "Western Sahara" },
  { value: "+967", text: "+967 (YE)", countryName: "Yemen" },
  { value: "+260", text: "+260 (ZM)", countryName: "Zambia" },
  { value: "+263", text: "+263 (ZW)", countryName: "Zimbabwe" },
];


const addressOption = [
  { value: "L", text: "Local" },
  { value: "F", text: "Foreign" },
];

const provinces = [
  { value: "Eastern Cape", text: "Eastern Cape" },
  { value: "Free State", text: "Free State" },
  { value: "Gauteng", text: "Gauteng" },
  { value: "KwaZulu Natal", text: "KwaZulu Natal" },
  { value: "Limpopo", text: "Limpopo" },
  { value: "Mpumalanga", text: "Mpumalanga" },
  { value: "Northern Cape", text: "Northern Cape" },
  { value: "North West", text: "North West" },
  { value: "Western Cape", text: "Western Cape" },
];

export default { countryList, areaCodes, addressOption, provinces };
